import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../components/footer/Footer'
import MegaHeader from '../components/MegaHeader/MegaHeader'
import { AiAgentPageData } from '../data/ai-agent-development'
import ServicesPageBanner from '../components/services-page-banner/ServicesPageBanner'
import TrustedPartner from '../components/trustedPartners/TrustedPartner'
import OurServices from '../components/our-services/OurServices'
import CoverTheStack from '../components/coverthestack/CoverTheStack'
import { useTranslation } from 'react-i18next'
import NewTestimonials from '../components/new-testimonials/NewTestimonials'
import WhyChooseUs from '../components/why-choose-us/WhyChooseUs'
import NewCaseStudySection from '../components/new-case-study-section/NewCaseStudySection'
import SimpleModels from '../components/simpleEngagementModels'
import PioneeringChange from '../components/pioneeringChange/PioneeringChange'
import tabData from '../data/industryData'
import FAQ from '../components/Fqas/FAQ'
import SoftwareCompanyCta from '../components/software-company-cta/SoftwareCompanyCta'
import TrendsInsights from '../components/trends-n-insights/TrendsInsights'
import MegaMenu from '../components/MegaMenu/MegaMenu'

const AIAgentDevelopment = () => {

    const { t: stackData } = useTranslation("customDevelopmentPage");
    const coverTheStackData = stackData("customDevPageCoverTheStack", {
        returnObjects: true,
    });

    return (
        <>
            <Helmet>
                <title>Custom AI & Voice Agent Development Services | Bitsclan</title>
                <meta
                    name="description"
                    content="Bitsclan offers top AI agent development services. Partner with our expert AI developers to build custom voice and ChatGPT-powered agents tailored to your business needs for scalable, intelligent growth."
                />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <link rel="canonical" href="https://bitsclan.com/ai-agent-development-services" />
            </Helmet>

            <MegaMenu />

            <ServicesPageBanner
                shortHeading={AiAgentPageData?.bannerContent?.shortHeading}
                mainHeading={AiAgentPageData?.bannerContent?.mainHeading}
                description={AiAgentPageData?.bannerContent?.description}
            />

            <TrustedPartner />

            <OurServices
                buttonText="Connect With Us"
                servicesCardsData={AiAgentPageData?.aiagentServices?.cardsData}
                shortHeading={AiAgentPageData?.aiagentServices?.shortHeading}
                mainHeading={AiAgentPageData?.aiagentServices?.heading}
                description={AiAgentPageData?.aiagentServices?.description}
            />

            <CoverTheStack
                whereStart="AI/ML Frameworks"
                mainHeading={"Foundational Technologies Driving Intelligent AI Agents"}
                shortHeading="Tools & Stack Technologies"
                subHeading={"At Bitsclan, we apply advanced agentic AI technologies to design customized, high-performance AI agent solutions. From smart automation to business optimization, our approach ensures scalability, reliability, & measurable results that strengthen your digital transformation journey."}
                tabs={AiAgentPageData?.techStack?.tabs}
                tabItems={AiAgentPageData?.techStack?.tabItems}
            />

            <NewTestimonials
                shortHeading="Customers Feedback for Our Agent Development"
                mainHeading={AiAgentPageData?.testimonialData?.mainHeading}
                description={AiAgentPageData?.testimonialData?.description}
                content={AiAgentPageData?.testimonialData?.testimonials}
            />

            <WhyChooseUs
                heading={AiAgentPageData?.whyUsContent?.heading}
                greenHeading={AiAgentPageData?.whyUsContent?.greenHeading}
                shortHeading={AiAgentPageData?.whyUsContent?.shortHeading}
                content={AiAgentPageData?.whyUsContent?.content}
                cta={AiAgentPageData?.whyUsContent?.cta}
                sectionImage={AiAgentPageData?.whyUsContent?.image}
                altText={AiAgentPageData?.whyUsContent?.altText}
            />

            <NewCaseStudySection
                shortHeading={AiAgentPageData?.caseStudyContent?.shortHeading}
                heading={AiAgentPageData?.caseStudyContent?.heading}
                description={AiAgentPageData?.caseStudyContent?.description}
            />

            <SimpleModels content={AiAgentPageData?.engagementModelContent} />

            <PioneeringChange
                tabData={AiAgentPageData?.industries?.tabData}
                serviceTags={AiAgentPageData?.industries?.serviceTags}
                shortHeading={"Industries We Serve"}
                greenHeading={"Global Industries With AI Agents"}
                mainHeading={"Shaping the Future of "}
                content={
                    "Driving innovation & transforming industries with advanced AI agent & voice agent development expertise & actionable insights."
                }
            />

            <TrendsInsights
                category="ai-developmet"
                heading={AiAgentPageData?.trendingInsights.heading}
                description={AiAgentPageData?.trendingInsights.description}
            />

            <FAQ
                faqs={AiAgentPageData.faqSection.questionAnswers}
                mainHeading={AiAgentPageData.faqSection.heading}
            />

            <SoftwareCompanyCta content={AiAgentPageData?.companyCta} />

            <Footer />
        </>
    )
}

export default AIAgentDevelopment